import HttpRequest from '@/libs/fileAxios'

const axios = new HttpRequest()
export default axios
